<template>
  <div class="container">
  <div v-if="preValidation">
    <div class="centre-column">
      <h2>Reset Password</h2>

      <div v-if="success">
        <p>
          Password successfully reset.  Please
          <router-link :to="{ name: 'login' }">log in</router-link>
        </p>
      </div>

      <div v-else>
        <form class="form-signin">

          <div v-bind:class="validatePassword ? '' : 'has-error'" class="form-group">
            <label for="inputPassword" class="sr-only">Password</label>
            <input v-model="password" type="password" id="inputPassword" class="form-control" placeholder="Password" required></input>
          </div>

          <div v-bind:class="validatePassword2 ? '' : 'has-error'" class="form-group">
            <label for="inputPassword2" class="sr-only">Re-enter Password</label>
            <input v-model="password2" type="password" id="inputPassword2" class="form-control" placeholder="Re-enter password" required></input>
          </div>

          <p v-if="!passwordsMatch" class="error">Passwords do not match</p>
          <p v-if="!passwordLength" class="error">Password must be at least {{ passwordMinLength }} characters</p>

          <button @click.prevent="submit" class="btn btn-lg btn-primary btn-block" type="submit">Reset</button>
        </form>

        <p v-if="error" class="error">We apologize, but your password could not be updated at this time.  Please contact Wedge Networks support for assisstance.</p>
      </div>
    </div>
  </div>

  <div v-else>
    <p>We are unable to reset your password at this time.  Please contact Wedge Networks support for assistance.</p>
  </div>
</div>
</template>

<style scoped>
.form-signin {
  max-width: 330px;
  margin: 0 auto;
}
.centre-column {
  max-width: 330px;
  margin: 1em auto;
}
p.error {
  color: red;
}
</style>

<script>
import auth from '../auth'

export default {
  data () {
    return {
      passwordMinLength: 6,
      password: '',
      password2: '',
      error: false,
      validate: false,
      success: false
    }
  },
  methods: {
    submit () {
      this.validate = true
      if (!this.isValid) {
        return
      }
      auth.resetPassword(this.password, this.accessToken)
      .then((result) => {
        this.success = true
      })
      .catch((error) => {
        this.error = true
        console.log('password reset error', error)
      })
    }
  },
  computed: {
    accessToken () {
      return this.$route.query.access_token
    },
    preValidation () {
      return !!this.accessToken
    },
    passwordsMatch () {
      return this.password === this.password2
    },
    passwordLength () {
      return !this.validate || this.password.length >= this.passwordMinLength
    },
    validatePassword () {
      return !this.validate || this.password !== ''
    },
    validatePassword2 () {
      return !this.validate || this.password2 !== ''
    },
    isValid () {
      return this.passwordsMatch && this.passwordLength && this.validatePassword && this.validatePassword2
    }
  }
}
</script>



// WEBPACK FOOTER //
// PasswordReset.vue?42389ee9